import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  colors, SovosRaisedButton, SovosFlatButton
} from 's1-ui';
import TextField from 'commonComponents/textField';
import logo from 'resources/full_logo.png';

const { primaryNavy, neutralWhite, buttonOrange } = colors;

const styles = {
  pageContainer: {
    backgroundColor: primaryNavy,
    position: 'fixed',
    overflowY: 'auto',
    height: 'calc(100vh - 30px)',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'column nowrap',
  },
  logo: {
    height: 50
  },
  headerText: {
    marginTop: 60,
    color: neutralWhite,
    fontSize: 35,
    fontWeight: 100
  },
  description: {
    marginTop: 20,
    color: neutralWhite,
    fontSize: 16,
    fontWeight: 300,
    maxWidth: 400,
    textAlign: 'center'
  },
  submitButton: {
    marginTop: 40
  },
  backToLogin: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'center'
  },
  backToLoginButton: {
    fontSize: 18
  },
  flatButton: {
    'button&:not(.another):not(.annoying):not(.specificity):not(.contest)': {
      padding: 0,
      textTransform: 'none'
    }
  },
};

const ResetPasswordDisplay = ({
  classes, form, errors, onChange, onKeyDown, onSubmit, backToLogin, loading
}) => (
  <div className={ classes.pageContainer }>
    <div>
      <img
        src={ logo }
        alt="shipcompliant_logo"
        className={ classes.logo }
      />
    </div>
    <div className={ classes.headerText }>
      Set New Password
    </div>
    <div className={ classes.description }>
      Enter your new password below.
    </div>
    <div>
      <div style={ { paddingTop: 30 } }>
        <TextField
          InputProps={ {
            placeholder: 'New Password',
            error: errors.newPassword !== undefined
          } }
          style={ { width: 350 } }
          label="New Password"
          value={ form.newPassword }
          onChange={ e => onChange('newPassword', e.target.value) }
          onKeyDown={ onKeyDown }
          type="password"
        />
      </div>
      <div style={ { paddingTop: 30 } }>
        <TextField
          InputProps={ {
            placeholder: 'Confirm Password',
            error: errors.confirmPassword !== undefined
          } }
          style={ { width: 350 } }
          label="Confirm Password"
          value={ form.confirmPassword }
          onChange={ e => onChange('confirmPassword', e.target.value) }
          onKeyDown={ onKeyDown }
          type="password"
        />
      </div>
      { errors.newPassword && (
        <div style={ { color: '#ff6b6b', marginTop: 10, fontSize: 14 } }>
          { errors.newPassword }
        </div>
      ) }
      { errors.confirmPassword && (
        <div style={ { color: '#ff6b6b', marginTop: 10, fontSize: 14 } }>
          { errors.confirmPassword }
        </div>
      ) }
    </div>
    <div className={ classes.submitButton }>
      <SovosRaisedButton
        color={ neutralWhite }
        backgroundColor={ buttonOrange }
        onClick={ onSubmit }
        disabled={ loading }
      >
        <span style={ { fontWeight: 300 } }>
          { loading ? 'RESETTING...' : 'RESET PASSWORD' }
        </span>
      </SovosRaisedButton>
    </div>
    <div className={ classes.backToLogin }>
      <SovosFlatButton
        className={ classes.flatButton }
        color={ buttonOrange }
        onClick={ () => backToLogin() }
      >
        <span className={ classes.backToLoginButton }>Back to Login</span>
      </SovosFlatButton>
    </div>
  </div>
);

ResetPasswordDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  backToLogin: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withStyles(styles)(ResetPasswordDisplay);
